import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 17.64 17.64' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='general_content' data-name='general content'>
        <path className='cls-1' d='M0 8.06h17.64v1.52H0z' />
        <path className='cls-1' d='M8.06 0h1.52v17.64H8.06z' />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/AddIcon.js